import { Order } from '../types/cart';

type OrderLike = Pick<Order, 'orderId' | 'orderItems'> | {
  orderId?: string | number;
  orderItems?: Array<{ itemName?: string | null }>;
};

const DEFAULT_LABEL = 'Order';

const normalizeItems = (order?: OrderLike) => {
  const items = order?.orderItems ?? [];
  return items.filter((item) => item && typeof item.itemName === 'string' && item.itemName.trim().length > 0);
};

export const getOrderItemSummary = (order?: OrderLike): string => {
  const validItems = normalizeItems(order);
  if (!validItems.length) {
    return DEFAULT_LABEL;
  }

  // Show all item names in a comma-separated list
  const itemNames = validItems.map(item => item.itemName!.trim()).filter(name => name.length > 0);
  
  if (itemNames.length === 0) {
    return DEFAULT_LABEL;
  }

  if (itemNames.length === 1) {
    return itemNames[0];
  }

  // Return comma-separated list of all items
  return itemNames.join(', ');
};

export const getOrderDisplayTitle = (order?: OrderLike): string => {
  const summary = getOrderItemSummary(order);
  if (summary !== DEFAULT_LABEL) {
    return summary;
  }

  if (order?.orderId !== undefined && order.orderId !== null) {
    return `Order #${order.orderId}`;
  }

  return DEFAULT_LABEL;
};

